import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { graphql, compose } from "react-apollo";

import { useAuthState, useAuthDispatch } from "../Context";
import { notify } from "../generic";
import { login, register } from "../../api/queries/utilisateur.mutations";
import ValidatedMyAccountForm from "../components/ValidatedMyAccountForm";
import WrappedUp from "../containers/WrappedUp";
import AccountList from "../components/AccountList";
import DetailsCompte from "./MyAccount/DetailsCompte";
import SecuriteCompte from "./MyAccount/SecuriteCompte";
import EntrepriseCompte from "./MyAccount/EntrepriseCompte";
import Loader from "../components/Loader";

function MyAccountPage(props) {
  const params = useParams();

  const { identifier = "" } = params;

  const pages = [
    {
      title: "Penge",
      identifier: "penge",
      subItems: [
        {
          title: "Détails du compte",
          identifier: ""
        },
        {
          title: "Sécurité",
          identifier: "securite"
        },
        {
          title: "Entreprise(s)",
          identifier: "entreprises"
        }
      ]
    },
    {
      title: "Mes comptes",
      identifier: "mes-comptes",
      subItems: [
        {
          title: "Comptes bancaires",
          identifier: "comptes"
        }
      ]
    }
  ];

  let loadedModule = <Loader />;

  switch (identifier) {
    default:
      loadedModule = <DetailsCompte />;
      break;
    case "securite":
      loadedModule = <SecuriteCompte />;
      break;
    case "entreprises":
      loadedModule = <EntrepriseCompte />;
      break;
  }
  return (
    <WrappedUp>
      <ul id="insideMenu">
        {pages.map(menuParent => {
          return (
            <li>
              {" "}
              <span className="subTitle">{menuParent.title}</span>
              <ul className="subMenu">
                {menuParent.subItems.map(menuChild => {
                  return (
                    <li>
                      <a
                        href={`/mon-compte/${menuChild.identifier}`}
                        className={`${
                          menuChild.identifier === identifier ? "active" : ""
                        }`}
                      >
                        {menuChild.title}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
      {loadedModule}
    </WrappedUp>
  );
}

export default compose(
  graphql(register, {
    name: "register"
  }),
  graphql(login, {
    name: "login"
  })
)(MyAccountPage);
